'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import CSSTransitionGroup from 'helpers/CustomCSSTransitionGroup';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingOverlay = exports.LoadingOverlay = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoadingOverlay, _Component);

  function LoadingOverlay() {
    (0, _classCallCheck3.default)(this, LoadingOverlay);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingOverlay.__proto__ || (0, _getPrototypeOf2.default)(LoadingOverlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingOverlay, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // If we want to show which processes are running, we should remove/change this.
      return this.props.isLoading !== nextProps.isLoading;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isLoading = _props.isLoading;

      var styles = require('./LoadingOverlay.scss');

      var transitionName = {
        enter: styles.enter,
        enterActive: styles['enter--active'],
        leave: styles.leave,
        leaveActive: styles['leave--active']
      };

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          component: 'div',
          transitionEnterTimeout: 100,
          transitionLeaveTimeout: 300,
          transitionName: transitionName
        },
        (isLoading || null) && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(className, styles.root) },
          _react2.default.createElement(_components.EnterpriseLoader, { key: 'enterprise-loader', className: styles.loader })
        )
      );
    }
  }]);
  return LoadingOverlay;
}(_react.Component), _class.propTypes = {
  isLoading: _react.PropTypes.bool,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  isLoading: false
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  var processesQueue = state.processesQueue;


  return {
    isLoading: !!(processesQueue && processesQueue.length)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(LoadingOverlay);


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoadingOverlay/LoadingOverlay.jsx
// module id = 1632
// module chunks = 0